// TODO: From App New
<template>
  <div class="d-flex align-items-center w-100">

    <!-- Title & Description -->
    <div class="flex-grow-1">
      <div class="d-flex align-items-center mb-1">
        <feather-icon
          icon="TagIcon"
          size="16"
          class="mr-50"
        />
        <h4 class="mb-0 mr-2">
          {{ (saleData && saleData.title) || 'Promo' }}
        </h4>
        <!-- Status Badge -->
        <b-badge
          v-if="saleData && saleData.status"
          :variant="getStatusVariant(saleData.status)"
          pill
          class="mr-1"
        >
          {{ getStatusLabel(saleData.status) }}
        </b-badge>
      </div>
      <div class="d-flex align-items-center mb-50">
        <p class="mb-0">
          <span class="text-muted">Dibuat oleh</span> {{ (saleData && saleData.owner_merchant && saleData.owner_merchant.name) || 'Brand' }}
        </p>
        <p class="text-muted mb-0 mx-1">
          |
        </p>
        <template v-if="saleData && (saleData.should_started_at || saleData.should_ended_at)">
          <span>
            <template v-if="saleData.should_started_at && saleData.should_ended_at">
              {{ formatSelectDate(saleData.should_started_at, ['date','month','year','time']) }} - {{ formatSelectDate(saleData.should_ended_at, ['date','month','year','time']) }}
            </template>
            <template v-else-if="saleData.should_started_at">
              Mulai {{ formatSelectDate(saleData.should_started_at, ['date','month','year','time']) }}
            </template>
            <template v-else>
              Berakhir {{ formatSelectDate(saleData.should_ended_at, ['date','month','year','time']) }}
            </template>
          </span>
        </template>
      </div>
    </div>

  </div>
</template>

<script>
import { BBadge } from 'bootstrap-vue'

export default {
  name: 'SaleInfo',
  components: {
    BBadge,
  },
  props: {
    selectedBrand: {
      type: Object,
      default: null,
    },
    saleData: {
      type: Object,
      default: null,
    },
  },
  methods: {
    getStatusVariant(status) {
      const statusMap = {
        inactive: 'secondary',
        ended: 'dark',
        failed_to_start: 'danger',
        failed_to_end: 'danger',
        starting: 'warning',
        ending: 'warning',
        waiting_to_start: 'warning',
        started: 'success',
      }
      return statusMap[status] || 'secondary'
    },
    getStatusLabel(status) {
      const statusLabels = {
        inactive: 'Tidak Aktif',
        ended: 'Berakhir',
        failed_to_start: 'Gagal Dimulai',
        failed_to_end: 'Gagal Berakhir',
        starting: 'Memulai',
        ending: 'Berakhir',
        waiting_to_start: 'Menunggu Dimulai',
        started: 'Dimulai',
      }
      return statusLabels[status] || status
    },
  },
}
</script>
